import { queueMicroTask } from './queueMicroTask';
var queueResizeObserver = function (cb) {
    queueMicroTask(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};
export { queueResizeObserver };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@juggle/resize-observer/lib/utils/queueResizeObserver.js
// module id = null
// module chunks = 